<div class="modal-body">
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="activeModal.dismiss()">
        <span aria-hidden="true"><img src="./assets/img/times.svg" class="img-fluid ico-title" width="20"></span>
    </button>
    <div class="d-flex justify-content-between align-items-center m-3">

        <div class="p-2 bd-highlight">
            <h5 align="center" class="tar-name"> {{ copyRate.name.trim() === 'Tarifa' ? copyRate.name + ' móvil' : copyRate.name }}</h5>
            <h5 align="center" class="tar-name-5 mb-1">{{ copyRate.voice }}</h5>
        </div>

        <div class="p-2 bd-highlight">
            <h5 align="center" class="tar-price">
                {{ copyRate.price }}<span> €/mes</span>
            </h5>
        </div>
        <div class="p-2 bd-highlight mobile">
            <h5 align="center" class="tar-name-4" [innerHTML]="getAmData(copyRate)"></h5>
            <h5 align="center" class="tar-name-5 mb-1">Navegación</h5>
        </div>
    </div>

    <div class="bb-line"></div>
    <br>

    <div *ngFor="let item of copyRate.infoDetails" class="m-3">
        <b style="font-size: 20px;">{{ item.title }}</b>
        <div [innerHTML]="item.description"></div>
    </div>
</div>
